// Values match the backend IncreaseWorkflowStep enum names. A const object rather
// than an enum because tsconfig enables erasableSyntaxOnly.
export const IncreaseWorkflowStep = {
  OpenPeriod: "OpenPeriod",
  CleanReportingLines: "CleanReportingLines",
  ManagerAllocation: "ManagerAllocation",
  BuApproval: "BuApproval",
  CrossBuReview: "CrossBuReview",
  SageSubmission: "SageSubmission",
  LockAndReport: "LockAndReport",
} as const

export type IncreaseWorkflowStep =
  (typeof IncreaseWorkflowStep)[keyof typeof IncreaseWorkflowStep]
